var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95 12.8167L13.2375 7.52925L12.1875 6.47925L7.95 10.7167L5.8125 8.57925L4.7625 9.62925L7.95 12.8167ZM3.75 16.4167C3.3375 16.4167 2.98438 16.2699 2.69063 15.9761C2.39687 15.6824 2.25 15.3292 2.25 14.9167V4.41675C2.25 4.00425 2.39687 3.65112 2.69063 3.35737C2.98438 3.06362 3.3375 2.91675 3.75 2.91675H14.25C14.6625 2.91675 15.0156 3.06362 15.3094 3.35737C15.6031 3.65112 15.75 4.00425 15.75 4.41675V14.9167C15.75 15.3292 15.6031 15.6824 15.3094 15.9761C15.0156 16.2699 14.6625 16.4167 14.25 16.4167H3.75ZM3.75 14.9167H14.25V4.41675H3.75V14.9167Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkbox_icon.f744745825207b7fa03cce6055e8b1db.svg";
export { ForwardRef as ReactComponent };